import { ComponentProps, ReactNode } from 'react';
import { Field } from './field';
import { FieldDescription } from './field-description';
import { FieldHelperText } from './field-helper-text';
import { FieldLabel } from './field-label';
import { FieldTopWrapper } from './field-top-wrapper';

type FieldWrapperProps = {
  className?: ComponentProps<typeof Field>['className'];
  error?: ComponentProps<typeof Field>['error'];
  label: ComponentProps<typeof FieldLabel>['children'];
  labelProps?: Omit<ComponentProps<typeof FieldLabel>, 'children'>;
  description: ComponentProps<typeof FieldDescription>['children'];
  descriptionProps?: Omit<ComponentProps<typeof FieldDescription>, 'children'>;
  children: ReactNode;
  helperText: ComponentProps<typeof FieldHelperText>['children'];
  helperTextProps?: Omit<ComponentProps<typeof FieldHelperText>, 'children'>;
};
export const FieldWrapper = ({
  className,
  children,
  label,
  labelProps,
  description,
  descriptionProps,
  helperText,
  helperTextProps,
  error,
}: FieldWrapperProps) => (
  <Field className={className} error={error}>
    <FieldTopWrapper>
      <FieldLabel {...labelProps}>{label}</FieldLabel>
      <FieldDescription {...descriptionProps}>{description}</FieldDescription>
    </FieldTopWrapper>
    {children}
    <FieldHelperText {...helperTextProps}>{helperText}</FieldHelperText>
  </Field>
);
